import { getTableLang } from "../../Utils/Inits/getTableLang";

export var  loadDt = function(table){
    const zeilen = ['Schüler/-innen', 'Schüler/-in']
    return {
      language: getTableLang({}, zeilen),
     // dom: "<'row'<'col-sm-12 d-flex align-items-center justify-content-end'f>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-12'p>>",
      fnDrawCallback: function ( oSettings ) {
        // $(oSettings.nTHead).hide();
        const $api = this.api();
        const pages = $api.page.info().pages;
        if (pages === 1){
          const pag = table.find(".dataTables_paginate")
          pag.css('display', 'none');
        }
      },
      columnDefs: [
        {"orderable": false, "targets": [3]}
      ]
    }
  }
  